import req from '@/service/api';
const user = {
    getAll() {
        return req('GET', '/prodid/getAll');
    }
};
export default user;
